import ProgressSteps from 'components/steps';
import { Button } from 'components/button';
import { OptionButton } from 'components/optionbutton';
import { useNavigate } from 'react-router-dom';

export const ImportMenuMethods = ({ onChangeStep, onGoBack }) => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: window.innerHeight }} className={`onflexlay`}>
      <div className="onbox">
        <h2>
          <strong>Add Menu</strong>
        </h2>
        <h5>Already have a menu</h5>
        <ProgressSteps active={3} />
        <div className="mt_15"></div>
        <OptionButton type="button" onClick={() => onChangeStep(4)}>
          <h4 className="ff_semi">Square Account</h4>
          <p>
            <strong>About Menu</strong>
          </p>
        </OptionButton>
        <div className="mt_15"></div>
        <OptionButton type="button" onClick={() => onChangeStep(5)}>
          <h4 className="ff_semi">External</h4>
          <p>
            <strong>About new menu</strong>
          </p>
        </OptionButton>
        <div className="mt_15"></div>
        <div className="pt_40"></div>
        <div className="onfooter">
          <Button
            type="button"
            label={`I'll do this later`}
            onClick={() => navigate('/dashboard')}
            className="alink"
            color="dark"
          />
          <div className="flex item_vcenter">
            <Button
              onClick={onGoBack}
              type="button"
              label={'Back'}
              color="outline-lite"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
